import React, { useEffect } from 'react'
import { message } from 'antd';
import Layouts from '../components/Layouts';
import { BrowserRouter } from "react-router-dom";
import Routes from '../routes';
import {  useSelector } from "react-redux";
import LoginForm from './loginForm';
function Login() {

  const auth = useSelector(state => state.auth)
  useEffect(() => {
    if (auth && auth.error) {
      console.log(auth);
      message.error(
        "The email or password you’ve entered doesn’t match any account"
      );
    }
  }, [auth]);

  if (!auth.isAuthenticated) {
    return (
      <LoginForm></LoginForm>
    )
  } else {
    return (
      <BrowserRouter>
        <Layouts>
          <Routes />
        </Layouts>
      </BrowserRouter>
    )
  }
}

export default Login
